
import { Vue, Component, Prop } from 'vue-property-decorator'
import { MenuItem } from '@/models'

@Component
export default class Action extends Vue {
  @Prop() item!: MenuItem
  @Prop() stylePanel!: boolean
}
